import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
import templateOnly from "@ember/component/template-only";
const DButtonTooltip = setComponentTemplate(precompileTemplate("\n  <div class=\"fk-d-button-tooltip\" ...attributes>\n    {{yield to=\"button\"}}\n    {{yield to=\"tooltip\"}}\n  </div>\n", {
  strictMode: true
}), templateOnly(undefined, "d-button-tooltip:DButtonTooltip"));
export default DButtonTooltip;